/**
 * ConfirmDeleteModal — Modal de confirmação de exclusão de ambiente
 */
import { useState } from 'preact/hooks';
import { ConfirmDialog } from '../../components/ui';

interface Props {
  name: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export function ConfirmDeleteModal({ name, onConfirm, onClose }: Props) {
  const [deleting, setDeleting] = useState(false);

  return (
    <ConfirmDialog
      open={true}
      onClose={() => { if (!deleting) onClose(); }}
      onConfirm={async () => {
        setDeleting(true);
        await onConfirm();
        setDeleting(false);
      }}
      title="Excluir Ambiente"
      message={`Tem certeza que deseja excluir ${name}? Esta ação é irreversível.`}
      confirmText={deleting ? 'Excluindo...' : 'Excluir'}
      cancelText="Cancelar"
      danger
      loading={deleting}
    />
  );
}
